import { useCallback, useEffect, useState } from "react";

export const useCountDown = ({ ...props }: UseCountDownProps): [number, (from?: number) => void, () => void] => {
    const [counter, setCounter] = useState<number>(props.from);
    const [isActive, setIsActive] = useState<boolean>(props.startOnMount ?? true);

    useEffect(() => {
        if (!isActive || counter === -1) {
            return;
        }

        if (counter > 0) {
            const timer = setInterval(() => setCounter(counter - 1), 1000);
            return () => clearInterval(timer);
        } else {
            props.onDone();
        }
    }, [counter, isActive]);

    const resetCounter = useCallback((from: number = props.from): void => {
        setCounter(from);
        setIsActive(true);
    }, []);

    const cancelCounter = useCallback((): void => {
        setIsActive(false);
        setCounter(-1);
    }, []);

    return [counter, resetCounter, cancelCounter];
};

/** Sleep for N seconds.
 * @param timer as seconds
 */
export const sleepFor = async (timer: number): Promise<void> => {
    return await new Promise((resolve) => {
        setTimeout(resolve, timer * 1000);
    });
};

interface UseCountDownProps {
    from: number;
    onDone: () => void;
    startOnMount?: boolean;
}
